import useActions from './useActions'

export const useInsertSearchParams = () => {
  const actions = useActions()
  return (params: { [key: string]: string }) => {
    actions.insertRouteArgs(params)

    const url = new URL(window.location.toString())
    const searchParams = url.searchParams
    for (const [key, value] of Object.entries(params)) {
      searchParams.set(key, value)
    }

    window.history.replaceState({}, document.title, url)
  }
}
